import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { MediaPayload } from '../configHelper';

export const unhideConditionOptions = [
  {
    key: Conditions.NewWithTags,
    label: 'New With Tags',
    description:
      'Your item has never been used and it contains original packaging. For this option, please take photos of the product in its original packaging.',
  },
  {
    key: Conditions.NewWithoutTags,
    label: 'New Without Tags',
    description:
      'Your item has never been used and the original hanging tags are still on. For this option, you’ll need to take pictures of the retail tags.',
  },
  {
    key: Conditions.Excellent,
    label: 'Excellent Condition',
    description:
      'Your item has only been slightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Good Condition',
    description:
      'You’ve used this item and it’s well maintained. There may be some quirks like matted material, but it’s overall in good shape. Please take pictures of any quirks the item has.',
  },
];

const getMediaForVariant = (
  media?: MediaPayload[],
  selectedVariantOptions?: Record<string, string | null>
) => {
  if (!media || !selectedVariantOptions) return media || [];

  const isVariantImage = (altText?: string) => {
    if (!altText) return false;

    const imgVariants = altText.split('~');
    const optionValues = Object.values(selectedVariantOptions).filter(Boolean);

    if (imgVariants.length === 1) {
      return imgVariants[0] === optionValues[0];
    }
    if (imgVariants.length === 2) {
      return imgVariants[0] === optionValues[0] && imgVariants[1] === optionValues[1];
    }
    if (imgVariants.length === 3) {
      return (
        imgVariants[0] === optionValues[0] &&
        imgVariants[1] === optionValues[1] &&
        imgVariants[2] === optionValues[2]
      );
    }
    return false;
  };

  const variantImages = media.filter((mediaItem) => isVariantImage(mediaItem.alt));

  // Return variant-specific images if found, otherwise return all media
  return variantImages.length > 0 ? variantImages : media;
};

export const unhideShopConfig = {
  ...getDefaultShopConfig(),
  filters: [...custom.filters, getConditionsFilterConfig({ options: unhideConditionOptions })],
  getMediaForVariant,
};
